import { defaultTeamImplementationSettings } from "../../../../components";
import { ITeamImplementationSettings, useSettings } from "../../../../hooks";

const useTeamImplementationSettings = (teamSlug: string) => {
  const {
    teamImplementationSettings: { [teamSlug]: unsafeSettings },
    updateTeamImplementationSettings,
  } = useSettings();

  const safeSettings: ITeamImplementationSettings = {
    ...defaultTeamImplementationSettings,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<ITeamImplementationSettings>) => {
      updateTeamImplementationSettings(teamSlug, updatedSettings);
    },
  };
};

export { useTeamImplementationSettings };
